(() => {
  const init = () => {
    const filters = document.querySelector('[data-sc-multiselect]');
    if (!filters || filters.dataset.ready) return;
    filters.dataset.ready = 'true';
    const root = filters.closest('collection-component');
    const copy = JSON.parse(filters.querySelector('[data-sc-copy]').textContent);
    const defaultSort = root.querySelector('[name="sort_by"]')?.value || '';
    const groups = [...new Set([...filters.querySelectorAll('[data-sc-group]')].map(el => el.dataset.scGroup))];
    const links = [...filters.querySelectorAll('[data-sc-tag]')];
    const valid = new Set(links.map(el => el.dataset.scTag));
    const size = Number(filters.dataset.pageSize);
    const cache = new Map();
    let generation = 0;
    let selected = new Set();
    let page = 1;
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    filters.append(status);
    let reset = filters.querySelector('.second-cuties-category-filters__reset');
    if (!reset) {
      reset = document.createElement('a');
      reset.href = filters.dataset.collectionUrl;
      reset.className = 'second-cuties-category-filters__reset';
      reset.textContent = copy.clear;
      filters.append(reset);
    }
    const readURL = () => {
      const params = new URL(location.href).searchParams;
      const values = params.has('sc_filter') ? params.getAll('sc_filter') : params.has('constraint') ? params.get('constraint').split('+') : location.pathname !== filters.dataset.collectionUrl ? JSON.parse(filters.dataset.currentTags || '[]') || [] : [];
      selected = new Set(values.filter(tag => valid.has(tag)));
      page = Math.max(1, Number(params.get('sc_page')) || 1);
    };
    const sync = () => {
      links.forEach(link => {
        const checked = selected.has(link.dataset.scTag);
        link.setAttribute('role', 'checkbox');
        link.setAttribute('aria-checked', String(checked));
        link.classList.toggle('is-active', checked);
        link.style.fontWeight = checked ? '700' : '';
        link.querySelector('[data-check]').textContent = checked ? '☑ ' : '☐ ';
      });
      filters.querySelectorAll('[data-sc-clear]').forEach(link => {
        link.classList.toggle('is-active', ![...selected].some(tag => tag.startsWith(link.dataset.scClear)));
      });
      reset.hidden = selected.size === 0;
      reset.style.display = selected.size ? '' : 'none';
    };
    links.forEach(link => {
      const check = document.createElement('span');
      check.dataset.check = '';
      check.setAttribute('aria-hidden', 'true');
      link.prepend(check);
      link.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); link.click(); }
      });
    });
    const writeURL = () => {
      const url = new URL(location.href);
      url.pathname = filters.dataset.collectionUrl;
      url.searchParams.delete('constraint');
      url.searchParams.delete('page');
      url.searchParams.delete('sc_filter');
      url.searchParams.delete('sc_page');
      selected.forEach(tag => url.searchParams.append('sc_filter', tag));
      if (page > 1) url.searchParams.set('sc_page', String(page));
      history.pushState({ scMultiselect: true }, '', url);
    };
    const load = async () => {
      const sort = new URL(location.href).searchParams.get('sort_by') || '';
      if (cache.has(sort)) return cache.get(sort);
      const promise = (async () => {
        const getPage = async n => {
          const url = new URL(filters.dataset.collectionUrl, location.origin);
          url.searchParams.set('section_id', filters.dataset.sectionId);
          url.searchParams.set('page', String(n));
          if (sort) url.searchParams.set('sort_by', sort);
          const response = await fetch(url);
          if (!response.ok) throw new Error('collection');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!doc.querySelector('[data-sc-multiselect]')) throw new Error('section');
          return doc;
        };
        const first = await getPage(1);
        const total = Number(first.querySelector('[data-sc-multiselect]').dataset.pages);
        const docs = [first];
        for (let n = 2; n <= total; n++) docs.push(await getPage(n));
        const seen = new Set();
        const items = docs.flatMap(doc => [...doc.querySelectorAll('[data-sc-product]')]).filter(item => {
          if (seen.has(item.dataset.scProduct)) return false;
          seen.add(item.dataset.scProduct);
          return true;
        }).map(node => ({ node, tags: JSON.parse(node.dataset.scTags) }));
        return { items, template: first.querySelector('#ProductGridContainer') };
      })();
      cache.set(sort, promise);
      try { return await promise; } catch (error) { cache.delete(sort); throw error; }
    };
    const render = async () => {
      const ticket = ++generation;
      sync();
      status.textContent = copy.loading;
      root.querySelector('#ProductGridContainer').setAttribute('aria-busy', 'true');
      try {
        const data = await load();
        if (ticket !== generation) return;
        const matches = data.items.filter(item => groups.every(group => {
          const choices = [...selected].filter(tag => tag.startsWith(group));
          return !choices.length || choices.some(tag => item.tags.includes(tag));
        }));
        const pages = Math.max(1, Math.ceil(matches.length / size));
        page = Math.min(page, pages);
        const container = data.template.cloneNode(true);
        container.querySelectorAll('.pagination-wrapper').forEach(el => el.remove());
        const grid = container.querySelector('#product-grid');
        grid.replaceChildren();
        matches.slice((page - 1) * size, page * size).forEach(item => {
          const node = item.node.cloneNode(true);
          node.classList.remove('scroll-trigger', 'animate--slide-in');
          node.querySelectorAll('[loading="lazy"]').forEach(img => img.loading = 'eager');
          grid.append(node);
        });
        container.classList.remove('scroll-trigger', 'animate--slide-in');
        if (!matches.length) {
          const empty = document.createElement('p');
          empty.className = 'page-width';
          empty.textContent = copy.empty;
          container.append(empty);
        }
        if (pages > 1) {
          const nav = document.createElement('nav');
          nav.setAttribute('aria-label', copy.pagination);
          nav.className = 'pagination-wrapper center';
          for (let n = 1; n <= pages; n++) {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = String(n);
            button.className = 'second-cuties-filter-option';
            button.setAttribute('aria-label', copy.page.replace('__PAGE__', n));
            if (n === page) { button.setAttribute('aria-current', 'page'); button.disabled = true; }
            button.addEventListener('click', () => { page = n; writeURL(); render(); filters.scrollIntoView({ block: 'start' }); });
            nav.append(button);
          }
          container.append(nav);
        }
        root.querySelector('#ProductGridContainer').replaceWith(container);
        root.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(el => { el.textContent = copy.count.replace('__COUNT__', matches.length); });
        status.textContent = copy.count.replace('__COUNT__', matches.length);
      } catch (error) {
        if (ticket !== generation) return;
        root.querySelector('#ProductGridContainer').removeAttribute('aria-busy');
        status.textContent = copy.error;
      }
    };
    filters.addEventListener('click', event => {
      const link = event.target.closest('[data-sc-tag], [data-sc-clear], .second-cuties-category-filters__reset');
      if (!link) return;
      event.preventDefault();
      if (link.dataset.scTag) {
        if (selected.has(link.dataset.scTag)) selected.delete(link.dataset.scTag);
        else selected.add(link.dataset.scTag);
      } else if (link.dataset.scClear) {
        selected = new Set([...selected].filter(tag => !tag.startsWith(link.dataset.scClear)));
      } else selected.clear();
      page = 1;
      writeURL();
      render();
    });
    root.addEventListener('input', event => {
      if (event.target.name !== 'sort_by') return;
      event.stopImmediatePropagation();
      const url = new URL(location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('sc_page');
      url.searchParams.delete('page');
      history.pushState({ scMultiselect: true }, '', url);
      page = 1;
      render();
    }, true);
    window.addEventListener('popstate', event => {
      event.stopImmediatePropagation();
      readURL();
      root.querySelectorAll('[name="sort_by"]').forEach(el => { el.value = new URL(location.href).searchParams.get('sort_by') || defaultSort; });
      render();
    }, true);
    readURL();
    sync();
    if (selected.size || new URL(location.href).searchParams.has('sc_page')) render();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
